import React from 'react'

export default function Heading({ children, tag, className }: { children: React.ReactNode, tag?: string, className?: string }) {
    return (
        <>
            {tag == "h1" ?
                <h1 className={`text-5xl leading-none sm:text-7xl md:text-8xl xl:text-9xl font-heading text-primary font-medium tracking-tight sm:tracking-tighter ${className || ''}`}>
                    {children}
                </h1>
                :
                <h2 className={`text-4xl sm:text-6xl font-heading text-primary font-medium tracking-tight sm:tracking-tighter ${className || ''}`}>
                    {children}
                </h2>
            }
        </>
    )
}
